import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import validator from 'validator';
import entityComposition from '../common/classes/entityComposition';
import TextInput from '../common/controls/textInput';
const AddEmailAddressModal = props => {
  const userID = props.userID,
    _props$employeeAction = props.employeeActions,
    serverShow = _props$employeeAction.serverShow,
    change = _props$employeeAction.change,
    serverSave = _props$employeeAction.serverSave,
    activeEmployee = props.employee.active;
  useEffect(() => {
    serverShow(userID);
  }, [serverShow, userID]);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValidEmail = _useState2[0],
    setIsValidEmail = _useState2[1];
  const handleChange = (field, newValue) => {
    setIsValidEmail(validator.isEmail(newValue));
    change(activeEmployee.id, 'email', newValue);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    className: "t-aeam"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement("div", {
    className: "h2"
  }, "Email Address Required"), /*#__PURE__*/React.createElement("div", {
    className: "h4"
  }, "TRU now requires that all accounts have an associated email address. This will ensure that you are able to retrieve your account information should you forget your password.")), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Input your email address:",
    field: "email",
    type: "email",
    entity: "Employee",
    onChange: handleChange,
    value: activeEmployee.email
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => serverSave(activeEmployee),
    disabled: !isValidEmail
  }, "Save")));
};
AddEmailAddressModal.propTypes = {
  userID: PropTypes.string.isRequired,
  employee: PropTypes.shape({
    active: PropTypes.shape({
      id: PropTypes.string,
      email: PropTypes.string
    })
  }).isRequired,
  employeeActions: PropTypes.shape({
    change: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func
  }).isRequired
};
export { AddEmailAddressModal as TestAddEmailAddressModal };
export default entityComposition(AddEmailAddressModal, ['employee'], {});